// @Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Third party
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'ngx-bootstrap';

// Local moduless
import { HomeRoutingModule } from './home-routing.module';
import { FlowModule } from '@app/flow';
import { SharedModule } from '@app/shared/shared.module';

// Local components
import { HomeComponent } from './home.component';

@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    TranslateModule,
    FlowModule,
    SharedModule,
    HomeRoutingModule
  ],
  declarations: [
    HomeComponent
  ],
  providers: []
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts